import { render } from "./CharacterSave.vue?vue&type=template&id=5a8b0ae2&scoped=true"
import script from "./CharacterSave.vue?vue&type=script&lang=js"
export * from "./CharacterSave.vue?vue&type=script&lang=js"

import "./CharacterSave.vue?vue&type=style&index=0&id=5a8b0ae2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8b0ae2"]])

export default __exports__